import type { ParsedUrlQuery } from 'querystring';
import type { ProvidersRouteParams } from 'types';
import { match, P } from 'ts-pattern';

export const buildRouteParams = (
  params: ParsedUrlQuery | undefined,
): ProvidersRouteParams => {
  if (!params) return { kind: null, state: null, city: null };

  const toValue = (x?: string | string[]): string | null =>
    match(x)
      .with(P.string, () => `${x}`)
      .otherwise(() => null);

  return {
    kind: toValue(params.kind),
    state: toValue(params.state),
    city: toValue(params.city),
  };
};

export const fullStateName = (state: string) =>
  match(state)
    .with('AL', () => 'Alabama')
    .with('AK', () => 'Alaska')
    .with('AZ', () => 'Arizona')
    .with('AR', () => 'Arkansas')
    .with('CA', () => 'California')
    .with('CO', () => 'Colorado')
    .with('CT', () => 'Connecticut')
    .with('DE', () => 'Delaware')
    .with('DC', () => 'District of Columbia')
    .with('FL', () => 'Florida')
    .with('GA', () => 'Georgia')
    .with('HI', () => 'Hawaii')
    .with('ID', () => 'Idaho')
    .with('IL', () => 'Illinois')
    .with('IN', () => 'Indiana')
    .with('IA', () => 'Iowa')
    .with('KS', () => 'Kansas')
    .with('KY', () => 'Kentucky')
    .with('LA', () => 'Louisiana')
    .with('ME', () => 'Maine')
    .with('MD', () => 'Maryland')
    .with('MA', () => 'Massachusetts')
    .with('MI', () => 'Michigan')
    .with('MN', () => 'Minnesota')
    .with('MS', () => 'Mississippi')
    .with('MO', () => 'Missouri')
    .with('MT', () => 'Montana')
    .with('NE', () => 'Nebraska')
    .with('NV', () => 'Nevada')
    .with('NH', () => 'New Hampshire')
    .with('NJ', () => 'New Jersey')
    .with('NM', () => 'New Mexico')
    .with('NY', () => 'New York')
    .with('NC', () => 'North Carolina')
    .with('ND', () => 'North Dakota')
    .with('OH', () => 'Ohio')
    .with('OK', () => 'Oklahoma')
    .with('OR', () => 'Oregon')
    .with('PA', () => 'Pennsylvania')
    .with('RI', () => 'Rhode Island')
    .with('SC', () => 'South Carolina')
    .with('SD', () => 'South Dakota')
    .with('TN', () => 'Tennessee')
    .with('TX', () => 'Texas')
    .with('UT', () => 'Utah')
    .with('VT', () => 'Vermont')
    .with('VA', () => 'Virginia')
    .with('WA', () => 'Washington')
    .with('WV', () => 'West Virginia')
    .with('WI', () => 'Wisconsin')
    .with('WY', () => 'Wyoming')
    .otherwise(() => 'NA');
